export const environment = {
  production: false,
  googleMapsApiKey: 'AIzaSyCmYf74xYNuTJ9wSOBNmBCANNZZp-JVFLQ',
  SERVER_HOST: 'https://api.preprod.quali-check.fr',
  API_PATH: 'https://api.preprod.quali-check.fr/api/v1/'
};



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/environments/environment.ts